export const MenuDB = [
  {
    id: 1,
    title: 'Products',
    url: '#products',
    faq: [
      {
        id: 1,
        question: 'Are Tucker Tub products vet approved?',
        answer:
          'Absolutely! We care about what we feed your dog. All our ingredients and products are approved by vets and pet nutritionists.'
      },
      {
        id: 2,
        question: 'Where are Tucker Tub ingredients sourced?',
        answer:
          'All our meats and vegetables are sourced from local Australian farms. Our meat comes from accredited farms in country Victoria that don’t use any preservatives or chemicals in their products. Over our many years of operating, we’ve been working with them to source high-quality meats just for your pup.'
      },
      {
        id: 3,
        question: 'Where are Tucker Tub products made?',
        answer:
          'All Tucker Tub branded products including our cooked, raw and treats range are delicately made with love in our PrimeSafe accredited kitchen in Broadford, Victoria, Australia.'
      },
      {
        id: 4,
        question: 'Is Tucker Tub suitable for my dog with sensitivities or allergies?',
        answer:
          'Yes, it is. We have significant experience working with different kinds of sensitivities and allergies. Our cooked Turkey & Vegetable Stew, Raw Turkey, Raw Kangaroo and Raw Venison products are often great for dogs with sensitivities and allergies. Don’t hesitate to reach out for a free consultation with one of our in-house pet nutritionists.'
      },
      {
        id: 5,
        question: 'How long does a Tucker Tub product last?',
        answer:
          'Cooked food and loaves can last for 5 – 7 days while our raw foods last 4 – 6 days if you keep them refrigerated after defrosting. We make all-natural, genuine dog food with zero additives or preservatives, shortening the shelf life of our products compared to commercial pet foods.'
      },
      {
        id: 6,
        question: 'Can I defrost and refreeze Tucker Tub products?',
        answer:
          'Yes, it is safe to thaw and refreeze our products. Refreezing does not impact the quality of the product.'
      }
    ]
  },
  {
    id: 2,
    title: 'Feeding',
    url: '#feeding',
    faq: [
      {
        id: 1,
        question: 'I’m interested in feeding raw, is it safe for my pet?',
        answer:
          'Yes! Dogs have a higher level of acidity in their digestive system that protects against pathogens, along with a shorter digestive tract. These allow dogs to tolerate a higher level of bacteria than humans. We were one of the first companies to produce raw pet food in Australia. Our experts are on hand to guide you through the transition to raw feeding. Don’t hesitate to book a free consultation with one of our specialists for advice.'
      },
      {
        id: 2,
        question: 'How much do I feed my dog?',
        answer:
          'Dog feed rates vary significantly with age, activity level, weight and other factors. A general rule of thumb is to feed your dog 30 – 40g per 1kg of body weight per day. With Tucker Tub products, you can usually feed them a little less; our food is energy-dense compared to commercial pet food. For more information, reach out to us. We’re happy to help!'
      },
      {
        id: 3,
        question: 'Is Tucker Tub suitable for my puppy?',
        answer:
          'Yes! We’ve fed thousands of puppies over the years and have seen them thrive on our all-natural dog food. We recommend our Chicken & Rice Stew, along with our Raw Chicken Mince for puppies. These products contain a great protein-to-fat ratio plus high levels of calcium for your growing pup. Feel free to reach out for recommendations specific to your puppy.'
      }
    ]
  },
  {
    id: 3,
    title: 'Company Information',
    url: '#company',
    faq: [
      {
        id: 1,
        question: 'When was Tucker Tub founded?',
        answer:
          'Tucker Tub was founded in 1996. With Tucker Tub you get our 25 years of experience in every product.'
      },
      {
        id: 2,
        question: 'Is Tucker Tub Australian owned and operated?',
        answer:
          'We sure are, true blue Aussie through and through! Tucker Tub is proudly Australian owned and operated with all of our products made in Australia in country Victoria. Only sourcing locally, we support Australian farmers and communities.'
      },
      {
        id: 3,
        question: 'Where is Tucker Tub based?',
        answer:
          'Tucker Tub is based in Broadford, Victoria, Australia.'
      }
    ]
  },
  {
    id: 4,
    title: 'Shipping & Delivery',
    url: '#shipping',
    faq: [
      {
        id: 1,
        question: 'Do you deliver to my area?',
        answer:
          'We are currently only delivering our fresh product range within Melbourne metro area, most of regional Victoria, and Sydney Metro. National delivery is coming soon, please check back shortly. Looking for treats? These are available nationally already. Available delivery options will update in the cart. If you need help with a delivery to your area, please contact us.'
      },
      {
        id: 2,
        question: 'How much does shipping cost?',
        answer:
          'Delivery is free for orders over $79 in metro Melbourne and over $99 in metro Sydney. If your order is below these amounts, or if you’re outside the metro areas, we charge a flat rate between $8.95 and $13.95 (inc GST) depending on your location.'
      },
      {
        id: 3,
        question: 'When will my order arrive?',
        answer:
          'We generally dispatch products once a week within 5 days. You will receive an email to notify you your order is on the way to your pup. For more information about our delivery schedule to your area please see this page: <a href="https://www.tuckertub.com.au/policies/shipping-and-delivery" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">https://www.tuckertub.com.au/policies/shipping-and-delivery</a>'
      },
      {
        id: 4,
        question: 'Do you accept returns?',
        answer:
          'Due to the perishable nature of our products, we do not accept returns. For any issues with our product, please contact us immediately on woof@tuckertub.com.au or over the phone.'
      }
    ]
  }
]
